import * as React from 'react';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Engagement } from '@ms/odsp-utilities/lib/logging/events/Engagement.event';
import './PreventDownload.scss';
import stringsResx from '../../Share.resx';
import { TooltipHost, DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';
import * as StringHelper from '@ms/odsp-utilities/lib/string/StringHelper';

export interface IPreventDownloadState {
  preventDownloadToggle: boolean;
}

export interface IPreventDownloadProps {
  onToggleChange?: (value: boolean) => void;
  isToggled: boolean;
  disablePreventDownload: boolean;
  detailsPane?: boolean;
}

export class PreventDownload extends React.Component<IPreventDownloadProps, IPreventDownloadState> {
  constructor(props: IPreventDownloadProps, context: any) {
    super(props);
    this.state = {
      preventDownloadToggle: false
    };

    this._onChanged = this._onChanged.bind(this);
  }

  public render(): React.ReactElement<{}> {
    // Toggle when not disabled and already checked.
    const isDisabled = this.props.disablePreventDownload;
    let isToggled = (!isDisabled && this.props.isToggled);
    const showTooltip = !this.props.detailsPane && this.props.disablePreventDownload;
    const offAriaLabel = showTooltip ? StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) : stringsResx.preventDownloadLabel;

    // Details pane always renders PreventDownload as disabled and checked.
    if (this.props.detailsPane) {
      isToggled = true;
    }

    return (
      <div className='od-PreventDownloadToggle'>
        <div className='od-PermissionsSettings-setting--PreventDownload-Icon'>
          <Icon iconName='Blocked2' />
        </div>
        <Toggle
          checked={ isToggled }
          disabled={ isDisabled }
          label={ stringsResx.preventDownloadLabel }
          offAriaLabel={ offAriaLabel }
          onChanged={ this._onChanged }
        />
        { showTooltip &&
          <div className='od-PreventDownloadToggle--info' data-is-focusable={ true } aria-Label={ StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) }>
            <TooltipHost
              hostClassName='od-preventDownload-tooltip'
              content={ StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) }
              directionalHint={ DirectionalHint.topCenter }
              calloutProps={ { gapSpace: 0 } }
              tooltipProps={ { maxWidth: '300px' } }
            >
              <Icon iconName={ 'Info' } className={ 'ms-Icon ms-Icon--Info' } />
            </TooltipHost>
          </div> }
      </div>
    );
  }

  private _onChanged(value: boolean): void {

    Engagement.logData({
      name: "PreventDownload.ToggleChanged",
      isIntentional: true
    });

    this.setState({
      preventDownloadToggle: value
    }, () => {
      this.props.onToggleChange(value);
    });
  }
}